import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { toastStore } from 'shared/ui'
import { Deferred, logger } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import {
  type IWorkflowTemplate,
  WorkflowTemplate,
} from 'pages/workflows/ui/CreateWorkflowModal/model/WorkflowTemplate'
import { WorkflowTemplateModal } from 'pages/workflows/ui/CreateWorkflowModal/ui/WorkflowTemplateModal'
import { WorkflowsRoutes } from 'pages/workflows'

export class CreateWorkflowStore {
  private _templateModalId = 'createWorkflowTemplateModal'

  constructor() {
    makeAutoObservable(this)
  }

  create = async (workflow = WorkflowTemplate.Create()) => {
    const deferred = new Deferred<boolean>()
    this._showTemplateStep(workflow, deferred)

    try {
      const completed = await deferred.future
      if (!completed || !workflow.templateName) return null

      uiStore.changeRoute({
        path: `${WorkflowsRoutes.root}/${WorkflowsRoutes.create}`,
        query: `template=${workflow.templateName}`,
      })
    } catch (error) {
      toastStore.add({
        title: 'Failed to create workflow',
        type: 'error',
      })

      logger.error(error)

      return null
    }
  }

  private _showTemplateStep = (workflow: IWorkflowTemplate, deferred: Deferred<boolean>) => {
    const onNext = () => {
      modalStore.removeModal(this._templateModalId)
      deferred.complete(true)
    }

    const onClose = () => {
      deferred.complete(false)
      modalStore.removeModal(this._templateModalId)
    }

    modalStore.addModal({
      id: this._templateModalId,
      title: 'Choose template',
      pureContent: true,
      ModalContent: WorkflowTemplateModal,
      ModalContentProps: { workflow, onNext },
      width: 480,
      onClose,
    })
  }
}
